 export const copartEnvironmentalFee = 15.00;
 export const copartGateFee = 95.00;
 export const copartTitlePickupFee = 20.00;
